(function () {
  const NETTLAGER_GID = 'gid://shopify/Location/74166141090';
  const API_VERSION = '2024-07';
  const ADDON_PROPERTIES = [
    '_aplcr_main_product_sku',
    '_sw_main_product_sku',
    '_vegglader_main_product_sku',
    '_gwp_main_product_sku',
  ];
  let debounceTimer = null;
  let activeCheck = null;
  let pendingDebounce = null;
  let _resolvePendingDebounce = null;
  let pendingCartChange = null;
  let _resolveCartChange = null;
  let _checkoutWaiting = false;

  function getToken() {
    const el = document.querySelector('meta[name="storefront-api-token"]');
    return el ? el.content : null;
  }

  function isAddon(item) {
    if (!item.properties) return false;
    return ADDON_PROPERTIES.some((key) => item.properties[key]);
  }

  function checkInventory() {
    if (activeCheck) return activeCheck;
    activeCheck = _runCheck().finally(function () {
      activeCheck = null;
      if (_resolveCartChange) _resolveCartChange();
    });
    return activeCheck;
  }

  async function _runCheck() {
    try {
      const cartRes = await fetch('/cart.js');
      if (!cartRes.ok) throw new Error(`Cart fetch failed: ${cartRes.status}`);
      const cart = await cartRes.json();

      if (!cart.items || cart.items.length === 0) {
        await setCartAttribute('true');
        return;
      }

      // Aggregate quantities per variant, excluding add-on items
      const variantQty = {};
      for (const item of cart.items) {
        if (isAddon(item)) continue;
        const gid = `gid://shopify/ProductVariant/${item.variant_id}`;
        variantQty[gid] = (variantQty[gid] || 0) + item.quantity;
      }

      const variantIds = Object.keys(variantQty);
      if (variantIds.length === 0) {
        await setCartAttribute('true');
        return;
      }

      const token = getToken();
      if (!token) {
        await setCartAttribute('false');
        return;
      }

      const query = `
        query PorterbuddyCheck($ids: [ID!]!) {
          nodes(ids: $ids) {
            ... on ProductVariant {
              id
              storeAvailability(first: 100) {
                edges {
                  node {
                    quantityAvailable
                    location { id }
                  }
                }
              }
            }
          }
        }
      `;

      const gqlRes = await fetch(`https://${Shopify.shop}/api/${API_VERSION}/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token,
        },
        body: JSON.stringify({ query, variables: { ids: variantIds } }),
      });

      if (!gqlRes.ok) throw new Error(`Storefront API failed: ${gqlRes.status}`);
      const json = await gqlRes.json();

      if (!json.data || json.errors) {
        console.error('[PorterbuddyInventory] GraphQL errors:', json.errors);
        await setCartAttribute('false');
        return;
      }

      let allInStock = true;

      for (const node of json.data.nodes) {
        if (!node || !node.storeAvailability) {
          allInStock = false;
          break;
        }
        const nettlager = node.storeAvailability.edges.find(
          (e) => e.node.location.id === NETTLAGER_GID
        );
        if (!nettlager || nettlager.node.quantityAvailable < variantQty[node.id]) {
          allInStock = false;
          break;
        }
      }

      await setCartAttribute(allInStock ? 'true' : 'false');
    } catch (e) {
      console.error('[PorterbuddyInventory]', e);
      try { await setCartAttribute('false'); } catch (_) {}
    }
  }

  function setCartAttribute(value) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { all_items_in_stock: value } }),
    });
  }

  var spinnerSvg = '<div class="loading-overlay__spinner"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>';

  function setButtonLoading(btn, loading) {
    if (loading) {
      if (!btn.querySelector('.loading-overlay__spinner')) {
        btn.insertAdjacentHTML('beforeend', spinnerSvg);
      }
      btn.classList.add('loading');
      btn.disabled = true;
    } else {
      var spinner = btn.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.remove();
      btn.classList.remove('loading');
      btn.disabled = false;
    }
  }

  // Called from cart.js at the start of a cart change operation.
  // Creates a promise that blocks checkout until the inventory check completes.
  window.porterbuddyCartChangeStarted = function () {
    if (pendingCartChange) return;
    _checkoutWaiting = false;
    var safetyTimer;
    pendingCartChange = new Promise(function (resolve) {
      _resolveCartChange = function () {
        clearTimeout(safetyTimer);
        resolve();
        _resolveCartChange = null;
        pendingCartChange = null;
      };
      // Safety: auto-resolve after 10s to prevent stuck checkout
      safetyTimer = setTimeout(_resolveCartChange, 10000);
    });
  };

  // Called from cart.js error paths when the cart mutation fails
  // so checkout doesn't hang waiting for an inventory check that will never run.
  window.porterbuddyCartChangeDone = function () {
    if (_resolveCartChange) _resolveCartChange();
  };

  // Runs silently in background — no UI blocking
  window.checkPorterbuddyInventory = function () {
    clearTimeout(debounceTimer);
    // Resolve old pendingDebounce so any submit handler waiting on it is unblocked
    if (_resolvePendingDebounce) _resolvePendingDebounce();
    pendingDebounce = new Promise(function (resolve) {
      _resolvePendingDebounce = resolve;
      debounceTimer = setTimeout(function () {
        pendingDebounce = null;
        _resolvePendingDebounce = null;
        resolve(checkInventory());
      }, 500);
    });
  };

  // Block checkout while a cart change + inventory check is in progress
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.id !== 'cart' || !e.submitter || e.submitter.name !== 'checkout') return;
    var waiting = pendingCartChange || pendingDebounce || activeCheck;
    if (!waiting) return;
    if (_checkoutWaiting) { e.preventDefault(); return; }
    _checkoutWaiting = true;
    e.preventDefault();
    var btn = e.submitter;
    setButtonLoading(btn, true);
    waiting.then(function () {
      _checkoutWaiting = false;
      setButtonLoading(btn, false);
      btn.click();
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    window.checkPorterbuddyInventory();
  });
})();
